var exports = {
  "Vs": "OkeyTile.module__tile___SWp5bX",
  "ai": "OkeyTile.module__number___SWp5bX",
  "d4": "OkeyTile.module__star___SWp5bX",
  "kL": "OkeyTile.module__clover___SWp5bX",
  "Mx": "OkeyTile.module__plays___SWp5bX",
};

module.exports = exports;
